import Vue from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './plugins/i18n'
import moment from './plugins/moment'

Vue.use(moment)

Vue.config.productionTip = false

new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#news-list__app')
